import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({
    server: 'numeroSerie', endPoint: `3ikAR4g3hM`, method: 'GET', body: null, token: null,
    mode: 'cors', credentials: 'omit'
  })
}
